export default function setFileUpload() {

  /* Elements */
  const fileElm = document.querySelectorAll('.js-fileUpload');

  /* アップロード時にファイル名を挿入 */
  for (let index = 0; index < fileElm.length; index++) {
    let btn = fileElm[index].querySelector('label');
    btn.addEventListener('change', (e) => {
      e.stopPropagation();
      let fileName = e.target.files[0] ? e.target.files[0].name : '';
      btn.nextElementSibling.innerHTML = fileName;
    })
    // errorがある時
    let error = fileElm[index].querySelector('.error');
    if (error != null) {
      fileElm[index].lastElementChild.appendChild(error);
    }
  }

  /* 確認ページでアップロードファイルの表示位置を調整 */
  if (document.querySelector('.mw-wp-form_file') != null) {
    let upLoadData = document.querySelectorAll('.mw-wp-form_file');
    upLoadData.forEach(elm => {
      let val = elm.parentNode.nextElementSibling;
      val.innerHTML = ''; // 選択されてませんを削除
      val.appendChild(elm);
    });
  }

}